import React, { useState } from "react";

const NAV_ITEMS = [
  { id: "venture", label: "MemoryAgent" },
  { id: "tech", label: "Focus" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export default function Header({ activeSection, scrollTo }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleNav = (id) => {
    setMobileOpen(false);
    scrollTo(id);
  };

  return (
    <>
      <nav className="nav-bar">
        <a
          href="#home"
          className="nav-bar__name"
          onClick={(e) => {
            e.preventDefault();
            scrollTo("home");
          }}
        >
          Korey Collazo
        </a>

        <ul className="nav-bar__links">
          {NAV_ITEMS.map(({ id, label }) => (
            <li key={id}>
              <button
                className={`nav-bar__link${activeSection === id ? " nav-bar__link--active" : ""}`}
                onClick={() => handleNav(id)}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>

        <button
          className="nav-bar__hamburger"
          onClick={() => setMobileOpen(true)}
          aria-label="Open navigation menu"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
      </nav>

      <div className={`mobile-nav${mobileOpen ? " mobile-nav--open" : ""}`}>
        <button
          className="mobile-nav__close"
          onClick={() => setMobileOpen(false)}
          aria-label="Close navigation menu"
        >
          &times;
        </button>
        {NAV_ITEMS.map(({ id, label }) => (
          <button
            key={id}
            className="mobile-nav__link"
            onClick={() => handleNav(id)}
          >
            {label}
          </button>
        ))}
      </div>
    </>
  );
}
